import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import React from "react";
import { DefaultLayout } from "../pages/Layout";
import { MinimalFormLayout } from "../components/layouts/MinimalFormLayout";
import { useAuth } from "../domain/api/auth";
const FormListPage = React.lazy(() => import("../pages/FormList"));
const EditFormPage = React.lazy(() => import("../pages/EditForm"));
const SubmissionsPage = React.lazy(() => import("../pages/Submissions"));
const DebugPage = React.lazy(() => import("../pages/Debug"));
const WebhooksPage = React.lazy(() => import("../pages/Webhooks"));
const AppPage = React.lazy(() => import("../pages/App"));
const AppListPage = React.lazy(() => import("../pages/AppList"));
const RequireAuth = ({ children }) => {
    const auth = useAuth();
    const location = useLocation();
    if (!auth.authenticated) {
        return _jsx(Navigate, { to: "/login", state: { from: location }, replace: true });
    }
    return children;
};
export const protectedRoutes = [
    {
        path: "/",
        element: (_jsx(RequireAuth, { children: _jsx(Outlet, {}) })),
        children: [
            {
                index: true,
                element: _jsx(Navigate, { to: "/forms", replace: true }),
            },
            {
                path: "/forms",
                element: _jsx(DefaultLayout, {}),
                children: [
                    {
                        index: true,
                        element: _jsx(FormListPage, {}),
                    },
                ],
            },
            {
                path: "/form/:formId",
                element: _jsx(DefaultLayout, {}),
                children: [
                    {
                        index: true,
                        element: _jsx(EditFormPage, {}),
                    },
                    {
                        path: "submissions",
                        element: _jsx(SubmissionsPage, {}),
                    },
                    {
                        element: _jsx(MinimalFormLayout, {}),
                        children: [
                            {
                                path: "debug",
                                element: _jsx(DebugPage, {}),
                            },
                            {
                                path: "apps",
                                children: [
                                    {
                                        index: true,
                                        element: _jsx(AppListPage, {}),
                                    },
                                    {
                                        path: ":appId",
                                        children: [
                                            {
                                                index: true,
                                                element: _jsx(AppPage, {}),
                                            },
                                            {
                                                path: "webhooks",
                                                children: [
                                                    {
                                                        index: true,
                                                        element: _jsx(WebhooksPage, {}),
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
